import React, { useState } from 'react';
import { Modal} from 'antd';
import {  AiOutlineMail} from "react-icons/ai";
import Signup from './EmailPassForm';
import './emailPassModal.css'

const Apps = () => {
  const [loading, setLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const showModal = () => {
    setOpen(true);
  };
  const handleOk = () => {
    setLoading(true);
    setTimeout(() => {
      setLoading(false);
      setOpen(false);
    }, 3000);
  };
  const handleCancel = () => {
    setOpen(false);
  };
  return (
    <>
      <label className='cont1'  onClick={showModal}>
        {/* Open Modal with customized footer */}
        <AiOutlineMail className='AppleLogo' style={{width:'10%', height:'22px'}} />
        <label className='cont-text'>Continue with Email</label>
      </label>
      <Modal
        open={open}
        // title="Let’s get started"
        onOk={handleOk}
        onCancel={handleCancel}
        footer={[
          // <Button key="back" onClick={handleCancel}>
          //   Return
          // </Button>,
          // <Button key="submit" loading={loading} onClick={handleOk}> Sign up</Button>,
          // <Button
          //   key="link"
          //   href="https://google.com"
          //   type="primary"
          //   loading={loading}
          //   onClick={handleOk}
          // >
          //   Search on Google
          // </Button>,
        ]}
      >
        {/* <div className="modal-child2"> */}
        <Signup 
      Submitbutton={<div className='Submit' loading={loading} onClick={handleOk}> Sign up</div>}
      Loginbutton={<div className='Submit' loading={loading} onClick={handleOk}> Login</div>}
      />
        
      </Modal>
    </>
  );
};
export default Apps;